import React from 'react';
import NotFoundPage from '@components/not-found';

interface Props {
  children: React.ComponentElement<any, any>;
  route: {
    flag: string;
  };
  userHasFlag: (flag: string) => boolean;
}

export const HasFlag: React.FC<Props> = ({children, route, userHasFlag, ...rest}) => {
  if (userHasFlag(route.flag)) {
    return children;
  }

  return <NotFoundPage withHeader={false} />;
};
